export const AddressAuthenticatedComponent = {
    template: `
        <oo-card>
            <oo-card-header>
                <p>Delivery Address</p>
            </oo-card-header>

            <oo-card-body>
                <oo-edit-pane
                    ng-if="!$ctrl.loading"
                    on-submit="$ctrl.onSubmit()"
                    on-cancel="$ctrl.onCancel()"
                    on-error="$ctrl.onError(err)"
                    missing-data="$ctrl.missingData()"
                >
                    <oo-read-state>
                        <address-card address="$ctrl.checkoutService.data.address"></address-card>
                    </oo-read-state>
                    <oo-edit-state>
                        <address-picker></address-picker>
                    </oo-edit-state>
                    <oo-error-state>
                        <address-suggestions
                            current-address="$ctrl.addressService.data"
                            error="$ctrl.addressService.errors"
                            on-address-selection="$ctrl._setAddressFromSuggestion(address)"
                            ></address-suggestions>
                    </oo-error-state>
                </oo-edit-pane>
            </oo-card-body>
        </oo-card>
    `,
    controller: class {
        constructor(accountService, checkoutService, $q, addressService, orderInfoService, $rootScope) {
            'ngInject';
            this.accountService = accountService;
            this.accountData = accountService.data;
            this.checkoutService = checkoutService;
            this.orderInfoService = orderInfoService;
            this.$q = $q;
            this.addressService = addressService;
            this.loading = true;
            this.$rootScope = $rootScope;
        }

        $onInit() {
            this.accountService.getAddresses()
                .finally(() => {
                    this._setInitialAddress();
                    this.loading = false;
                });
        }

        onSubmit() {
            return this.addressService.validateWithDeliveryRange(this.addressService.data)
                .then(address => this._saveAddress(address))
                .then(address => this._setAddress(address))
                .then(
                    () => this.addressService.updateDeliveryFee(),
                    error => this.$q.reject(error)
                );
        }

        onCancel() {
            this.addressService.setAddress(this.checkoutService.data.address);
        }

        onError(err) {
            // TODO Dead code?
            this.errorMessage = err.errorMessage.errorMessage;
            this.suggestedAddresses = err.suggestedAddresses;
        }

        missingData() {
            return !this.addressService.isComplete(this.checkoutService.data.address);
        }

        _setAddressFromSuggestion(address) {
            this.addressService.setAddress(address);
            this.$rootScope.$broadcast('angucomplete-alt:changeInput', 'geo-input-suggest', address);
        }

        _setInitialAddress() {
            if(this.accountData.addresses.length > 0) {
                let address = this._findStoredAddress();
                this._setAddress(address);
            } else {
                let address = this.orderInfoService.getDeliveryInfo();
                if(address && !address.guid) this._setAddress(address);
                else this._clearAddress();
            }
        }

        _findStoredAddress() {
            let storedAddress = this.orderInfoService.getDeliveryInfo();
            let savedAddress = this.accountData.addresses.find(address => storedAddress.guid === address.guid);
            if(!savedAddress) savedAddress = this.accountData.addresses[0];
            return savedAddress;
        }

        _saveAddress(address) {
            if(address.shouldSave) {
                const permanent = true;
                return this.addressService.geocodeAddress(address, permanent)
                    .then(
                        addr => this.accountService.addAddress(addr),
                        error => this.$q.reject(error)
                    );
            }
            return this.$q.resolve(address);
        }

        _setAddress(address) {
            address.shouldSave = false;
            this.addressService.setAddress(address);
            this.checkoutService.setAddress(address);
            return address;
        }

        _clearAddress() {
            this.addressService.clearAddress();
            this.checkoutService.clearAddress();
        }
    }
};
